import { useState } from "react";
import { toast } from "sonner";
import { inputCls, Field, CheckGroup, GoldButton, meetsMinimums, Honeypot, PrivacyNote } from "./fields";
import { useDraft } from "./useMember";
import { useSubmitApplication } from "./useSubmitApplication";

const EMPTY = { name: "", hometown: "", experience: "", availability: "", skills: [], bio: "", video_url: "" };

export const FirstMateForm = ({ options, headers, onCreated }) => {
  const [form, setForm, clear] = useDraft("cc_draft_first_mate", EMPTY);
  const { busy, submit } = useSubmitApplication({ path: "first-mate", headers, onCreated, clearDraft: clear });
  const [showErrors, setShowErrors] = useState(false);
  const [website, setWebsite] = useState("");
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const MINS = [[form.name, 2], [form.experience, 10], [form.availability, 2]];

  const onSubmit = (e) => {
    e.preventDefault();
    if (!meetsMinimums(MINS)) { setShowErrors(true); toast.error("Please complete the highlighted fields."); return; }
    submit({ ...form, website }, form.name);
  };

  return (
    <form onSubmit={onSubmit} noValidate className="space-y-5" data-testid="first-mate-form">
      <p className="text-xs text-[#94A3B8] border border-[#D4AF37]/25 bg-[#070A0F] p-3 leading-relaxed">
        No captain's license required. Tell us what you bring aboard.
      </p>
      <Field label="Full name" value={form.name} minLength={2} showErrors={showErrors} testId="mate-name">
        <input required value={form.name} onChange={set("name")} placeholder="Full name" className={inputCls} data-testid="mate-name" />
      </Field>
      <Field label="Hometown" hint="optional">
        <input value={form.hometown} onChange={set("hometown")} placeholder="e.g. Avalon, Catalina Island" className={inputCls} data-testid="mate-hometown" />
      </Field>
      <Field label="Experience" value={form.experience} minLength={10} showErrors={showErrors} testId="mate-experience">
        <textarea required rows={4} value={form.experience} onChange={set("experience")}
          placeholder="Time on the water, boats you've crewed, roles you've held…" className={inputCls} data-testid="mate-experience" />
      </Field>
      <Field label="Availability" value={form.availability} minLength={2} showErrors={showErrors} testId="mate-availability">
        <input required value={form.availability} onChange={set("availability")}
          placeholder="e.g. Weekends through summer; flexible for a 10-day shoot" className={inputCls} data-testid="mate-availability" />
      </Field>
      <CheckGroup label="Skills & comfort" hint="check all that apply" options={options.mate_skills}
        value={form.skills} onChange={(v) => setForm((f) => ({ ...f, skills: v }))} testPrefix="mate-skill" />
      <Field label="Your sea story" hint="optional — shown on your public card">
        <textarea rows={3} value={form.bio} onChange={set("bio")} placeholder="Why do you deserve a berth?" className={inputCls} data-testid="mate-bio" />
      </Field>
      <Field label="Audition video URL" hint="YouTube or Vimeo — optional">
        <input value={form.video_url} onChange={set("video_url")} placeholder="https://youtube.com/…" className={inputCls} data-testid="mate-video" />
      </Field>
      <Honeypot value={website} onChange={(e) => setWebsite(e.target.value)} />
      <PrivacyNote>Your name, hometown, sea story and skills appear on your public voting card; your email stays private and is kept only for casting.</PrivacyNote>
      <GoldButton type="submit" disabled={busy} data-testid="mate-submit">{busy ? "SENDING…" : "SUBMIT FIRST MATE APPLICATION"}</GoldButton>
    </form>
  );
};
